<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="member" v-if="member.memberStatus===1">
			<div class="list">
				<div class="warmTips" v-if="list.content && !list.content.length">
					<img src="../../assets/images/404.png"/>
					<span>没有找到相应内容哦</span>
				</div>
				<ul class="meeting_box">
					<li v-for="(item,index) in list.content" :key="index" >
						<div class="fonts"  @click="showPdf(item.enclosureId)">
							<h4>标题：{{item.title}}</h4>
							<p>描述：{{item.description}}</p>
						</div>
						<!-- <div class="seeBox">
							<i class="el-icon-view"></i>
							浏览
						</div> -->
					</li>
				</ul>
			</div>
		</div>
		<div class="noMember" v-else>
			<h4>正式会员可查看</h4>
		</div>
	</div>
</template>

<script>
import {Button,Toast } from 'vant';
import vHead from "../../components/Subhead.vue";
import {getResource,getCurrentAccount} from "@/api/dictionary";
import {getSessionStore} from "@/utils/sessionStorage.js"
export default {
  data() {
    return {
		list:[],
		isSelect:0,
		member:{},
		title:"资源共享",
		page:1,
		params:{
			name:null,
			title:null,
			content:"",
			userId:"",
			status:1
		}
    };
  },
  filters: {
    
  },
  components: {
	  vHead,
	  [Button.name]: Button,
	  [Toast.name]: Toast,
  },
  methods: {
	  getData() {
		  let identity = this.member.identity;
		  let branchidentity = this.member.branchIdentity;
		  let params = {};
		  if(null!=identity&&null!=branchidentity){
			  if(identity<=branchidentity){
				  params.identityType = identity;
			  }else {
				  params.identityType = branchidentity;
			  }
		  }else {
			  params.identityType = 7;
		  }
		  getResource(params, this.page - 1).then(res=>{
		  	if(res.success){
		  		this.list = res.result;
			}else {
		  		Toast.fail(res.message);
			}
		  })
	  },
	  showPdf(url){
		  this.$router.push({path:"/preview",query:{"url":url}});
	  },
	  getMember() {
		  const me = this;
		  let token = getSessionStore("access_token");
		  if (token) {
			  getCurrentAccount({
				  access_token: token
			  })
					  .then(resp => {
						  me.member = resp.result;
						  if (me.member.memberStatus === 1) {
							  this.getData();
							  $(".noMember").css("display","none");
							  $(".noMember").css("color","red");
							  $(".member").css("display","block");
						  } else {
							  $(".noMember").css("display","block");
							  $(".member").css("display","none");
						  }
					  })
					  .catch(err => {});
		  }
	  },
  },
  computed: {
    
  },
	watch:{
		isSelect(){
			this.getData();
		},
	},
  mounted() {
	  //获取到用户信息  判断他的状态 如果不是正式会员 跳转页面  或者弹出提示 遮罩
	  this.getMember();
  }
}
</script>
<style lang="less" scoped>
	/*.tabbtn{ width: 100%; display: inline-flex; }*/
	/*.tabbtn li{ width: 33.3%; text-align: center; font-size:14px; padding: 20px 0; border-bottom: #dfdfdf solid 2px;}*/
	/*.tabbtn li.current{ border-color: red }*/
	.list{ padding:0 15px;}
	.list li{ padding: 15px 0; font-size: 15px; color: #000; border-bottom: #dfdfdf solid 1px;}
	.list li p{ font-size:14px; color: #666; margin: 10px 0; }
	.noMember{    font-size: 0.42667rem;
    text-align: center;
    margin-top: 55%;}
</style>